import HandIcon from "/static/images/landing/icons/hands.svg"
import PercentageIcon from "/static/images/landing/icons/percentage.svg"
import CoinIcon from "/static/images/landing/icons/coin.svg"
import ShieldIcon from "/static/images/landing/icons/shield.svg"
import classNames from "classnames"

import "./Item.scss"

const Item = ({ content }) => {
  const icons = {
    hands: HandIcon,
    percentage: PercentageIcon,
    coin: CoinIcon,
    shield: ShieldIcon,
  }

  const Icon = icons[content.icon]

  return (
    <div
      className={classNames("landing-numbers-item", {
        "landing-numbers-item--width-limit": content.widthLimit,
      })}
    >
      <Icon className="landing-numbers-item__icon" />

      <div className="landing-numbers-item__content">
        <h3 className="landing-numbers-item__title">{content.title}</h3>

        <p className="landing-numbers-item__description">
          {content.description}
        </p>
      </div>
    </div>
  )
}

export default Item
